import ModalVideo from 'react-modal-video';
import React, { useState } from 'react';

function Grid() {
   const [isOpen, setOpen] = useState(false);
   return (
      <>
         <div className="grid">
            <div>
               <img
                  srcset="/ReactAssets/CustomerJourney/Home1x1.jpg 1x, /ReactAssets/CustomerJourney/Home1x2.jpg 2x"
                  src="/ReactAssets/CustomerJourney/Home1x1.jpg"
                  alt="Home 1"
               />
            </div>
            <div onClick={() => setOpen(true)} className="vid-opener">
               <img
                  srcset="/ReactAssets/CustomerJourney/Home2x1.jpg 1x, /ReactAssets/CustomerJourney/Home2x2.jpg 2x"
                  src="/ReactAssets/CustomerJourney/Home2x1.jpg"
                  alt="Home 1"
               />
            </div>
            <div>
               <img
                  srcset="/ReactAssets/CustomerJourney/Home3x1.jpg 1x, /ReactAssets/CustomerJourney/Home3x2.jpg 2x"
                  src="/ReactAssets/CustomerJourney/Home3x1.jpg"
                  alt="Home 1"
               />
            </div>
            <div>
               <img
                  srcset="/ReactAssets/CustomerJourney/Home4x1.jpg 1x, /ReactAssets/CustomerJourney/Home4x2.jpg 2x"
                  src="/ReactAssets/CustomerJourney/Home4x1.jpg"
                  alt="Home 1"
               />
            </div>
         </div>
         <ModalVideo
            channel="youtube"
            autoplay
            isOpen={isOpen}
            videoId="ptwNYZIj_QQ"
            onClose={() => setOpen(false)}
            ratio="1:1"
         />
      </>
   );
}

export default Grid;
